import React, { useState, useEffect } from 'react';
import './WarningScreen.css';
import GameContentProvider from '../providers/GameContentProvider';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AncientSofiaHook from '../starters/AncientSofiaHook';
import PackYourBagHook from '../starters/PackYourBagHook';
import DiscoverVarnaHook from '../starters/DiscoverVarnaHook';
import DiscoverPlovdivHook from '../starters/DiscoverPlovdivHook';

const WarningScreen = () => {
    const { t } = useTranslation();

    const [inputValue, setInputValue] = useState('');
    const [selectedDateTime, setSelectedDateTime] = useState(null);
    const [gameId, setGameId] = useState(null);
    const [gameDuration, setDuration] = useState(null);
    const [game_number_of_steps, setNumberOfSteps] = useState(null);
    const [game_start_location, setGameStartLocation] = useState(null);
    const [gameType, setGameType] = useState(1);
    const [showError, setShowError] = useState(false);
    const [coupon, setCoupon] = useState(null);
    const [teamGameId, setTeamGameId] = useState(null);
    const [play, setPlay] = useState(null);
    const [gameCode, setCode] = useState(null);
    const [startTime, setStartTime] = useState(null);
    // const [isFromBulgaria, setIsFromBulgaria] = useState(false);
    const [isFromBulgaria, setIsFromBulgaria] = useState(true); // disable gps verification
    const [gpsVerified, setGpsVerified] = useState(false);
    const [gpsCheckInProgress, setGpsCheckInProgress] = useState(false);
    const [showHook, setShowHook] = useState(false);
    const [showBagHook, setShowBagHook] = useState(false);
    const [showDiscoverVarnaHook, setShowDiscoverVarnaHook] = useState(false);
    const [showDiscoverPlovdivHook, setShowDiscoverPlovdivHook] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const { game, coupon, type, duration, number_of_steps, start_location } = location.state || {};
        if (game) setGameId(game);
        if (coupon) setCoupon(coupon);
        if (type) setGameType(type);
        if (duration) setDuration(duration);
        if (number_of_steps) setNumberOfSteps(number_of_steps);
        if (start_location) setGameStartLocation(start_location);
    }, [location.state]);

    useEffect(() => {
        fetch("https://ipapi.co/json/")
            .then((res) => res.json())
            .then((data) => {
                if (data && data.country === "BG") {
                    setIsFromBulgaria(true);
                    console.log("User is from Bulgaria.");
                } else {
                    console.log("User is NOT from Bulgaria.");
                }
            })
            .catch((err) => {
                console.error("IP lookup failed:", err);
            });
    }, []);

    const verifyGPSLocation = () => {
        setGpsCheckInProgress(true);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const isInBulgaria =
                        latitude >= 41.2 && latitude <= 44.2 &&
                        longitude >= 22.3 && longitude <= 28.6;

                    if (isInBulgaria) {
                        setIsFromBulgaria(true);
                        setGpsVerified(true);
                    } else {
                        alert("You are not within Bulgaria.");
                    }
                    setGpsCheckInProgress(false);
                },
                (error) => {
                    alert("Failed to get GPS location. Please allow location access.");
                    console.error(error);
                    setGpsCheckInProgress(false);
                }
            );
        } else {
            alert("Geolocation is not supported by your browser.");
            setGpsCheckInProgress(false);
        }
    };

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleDateTimeChange = (date) => {
        setSelectedDateTime(date);
    };

    const actualStartGame = async () => {
        try {
            let token = localStorage.getItem('token') || localStorage.getItem('guest_token');
            const gameContentProvider = new GameContentProvider();
            const playDetails = await gameContentProvider.startGame(gameId, inputValue.trim(), coupon, token);
            setPlay(playDetails);
            const data = {
                game: gameId,
                step: 1,
                type: gameType,
                play_id: playDetails.play_id
            };
            const otherComponentURL = '/game-steps';
            const gameStepsWindow = window.open(otherComponentURL, '_blank');
            gameStepsWindow.addEventListener('load', () => {
                gameStepsWindow.postMessage(data, window.origin);
            });

            navigate('/', { replace: true });
        } catch (error) {
            console.error('Error starting game:', error);
        }
    };

    const handleButtonClick = async () => {
        let token = localStorage.getItem('token') || localStorage.getItem('guest_token');

        if (inputValue.trim() === '') {
            setShowError(true);
        } else if (!isFromBulgaria && !gpsVerified) {
            console.log("User is not in Bulgaria");
            setShowError(true);
        } else {
            try {
                if (gameType === 2) {
                    if (selectedDateTime == null) {
                        setShowError(true);
                    } else {
                        const selectedDateTimeFormatted = new Date(selectedDateTime).toLocaleString('sv-SE').replace('T', ' ');
                        const gameContentProvider = new GameContentProvider();
                        const code = await gameContentProvider.startTeamGame(gameId, inputValue.trim(), coupon, selectedDateTimeFormatted, token);
                        setCode(code.code);
                        setTeamGameId(code.team_game_id);
                        setStartTime(code.start_time);

                        const data = {
                            game_id: gameId,
                            code: code.code,
                            start_date: code.start_time,
                            team_game_id: code.team_game_id,
                        };
                        navigate('/waiting_screen', { state: data });
                    }
                } else {
                    if (Number(gameId) === 10) {
                        setShowHook(true);
                    } else if (Number(gameId) === 9) {
                        setShowBagHook(true);
                    } else if (Number(gameId) === 8) {
                        setShowDiscoverVarnaHook(true);
                    }
                    else if (Number(gameId) === 15) {
                        setShowDiscoverPlovdivHook(true);
                    } else {
                        await actualStartGame();
                    }
                }
            } catch (error) {
                console.error('Error fetching game details:', error);
            }
            setShowError(false);
        }
    };

    const closeModal = () => {
        setShowError(false);
    };

    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 7);

    if (showHook) {
        return <AncientSofiaHook onGameStart={actualStartGame} />;
    }

    if (showBagHook) {
        return <PackYourBagHook onStartGame={actualStartGame} />;
    }

    if (showDiscoverVarnaHook) {
        return <DiscoverVarnaHook onGameStart={actualStartGame} />;
    }

    if (showDiscoverPlovdivHook) {
        return <DiscoverPlovdivHook onGameStart={actualStartGame} />;
    }

    return (
        <div className="warningscreen">
            <div className='background-image-warning-screen'></div>
            <div className="center-container-warning-screen">
                <h2>{t('start')}</h2>
                <p>{t('start_message1')} {game_number_of_steps} {t('start_message2')} {gameDuration} {t('start_message3')}</p>
                <p>{t('game_starts_near')} {game_start_location}.{t('be_closeby')}</p>
                <p>{t('team_name')}</p>
                <input
                    type="text"
                    placeholder={t('team_name_placeholder')}
                    value={inputValue}
                    onChange={handleInputChange}
                />

                {gameType === 2 && (
                    <div>
                        <p>{t('select_datetime')}</p>
                        <DatePicker
                            selected={selectedDateTime}
                            onChange={handleDateTimeChange}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={5}
                            dateFormat="dd.MM.yyyy HH:mm"
                            placeholderText={t('select_datetime_placeholder')}
                            minDate={new Date()}
                            maxDate={maxDate}
                        />
                    </div>
                )}
                <button onClick={handleButtonClick}>{t('start_button')}</button>
            </div>

            {showError && (
                <div className="overlay">
                    <div className="overlay-content">
                        <h3>{t('error')}</h3>
                        <p>{isFromBulgaria || gpsVerified ? t('team_name_empty') : t('start_game_not_in_bg')}</p>

                        {!isFromBulgaria && !gpsVerified && (
                            <div>
                                <p>{t('verify_location_prompt')}</p>
                                <button onClick={verifyGPSLocation} disabled={gpsCheckInProgress}>
                                    {gpsCheckInProgress ? t('checking_location') : t('verify_location')}
                                </button>
                            </div>
                        )}

                        <button onClick={closeModal}>{t('close')}</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WarningScreen;
